import React from "react";
import { Outlet } from "react-router-dom";
import BreadcrumbsSwitcher from "../components/BreadcrumbsSwitcher";

const SalesLayout = ({ children }) => {
  return (
    <div>
      <div className="px-4 my-3">
        <BreadcrumbsSwitcher />
      </div>
      <Outlet />
    </div>
  );
};

export default SalesLayout;
